module.exports = __webpack_public_path__ + "media/crypto/eth-be205ad0.png";